// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { notebook16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-notebook': IconNotebook;
    }
}

/**
 * The icon component for the 'notebook' icon
 */
export class IconNotebook extends Icon {
    public constructor() {
        super(notebook16X16);
    }
}

registerIcon('icon-notebook', IconNotebook);
export const iconNotebookTag = 'nimble-icon-notebook';
